'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Throttle = Throttle;

var _lodash = require('lodash');

var _DecorateInstance = require('./DecorateInstance');

/**
 * @param {number} duration
 * @param {{}} [options]
 */
function Throttle(duration, options) {

  return (0, _DecorateInstance.DecorateInstance)(_lodash.throttle, duration, options);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9UaHJvdHRsZS5qcyJdLCJuYW1lcyI6WyJUaHJvdHRsZSIsImR1cmF0aW9uIiwib3B0aW9ucyJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFPZ0JBLFEsR0FBQUEsUTs7QUFQaEI7O0FBQ0E7O0FBRUE7Ozs7QUFJTyxTQUFTQSxRQUFULENBQWtCQyxRQUFsQixFQUE0QkMsT0FBNUIsRUFBcUM7O0FBRXhDLFNBQU8sMERBQTJCRCxRQUEzQixFQUFxQ0MsT0FBckMsQ0FBUDtBQUVIIiwiZmlsZSI6IlRocm90dGxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHt0aHJvdHRsZX0gZnJvbSAnbG9kYXNoJztcbmltcG9ydCB7RGVjb3JhdGVJbnN0YW5jZX0gZnJvbSAnLi9EZWNvcmF0ZUluc3RhbmNlJztcblxuLyoqXG4gKiBAcGFyYW0ge251bWJlcn0gZHVyYXRpb25cbiAqIEBwYXJhbSB7e319IFtvcHRpb25zXVxuICovXG5leHBvcnQgZnVuY3Rpb24gVGhyb3R0bGUoZHVyYXRpb24sIG9wdGlvbnMpIHtcblxuICAgIHJldHVybiBEZWNvcmF0ZUluc3RhbmNlKHRocm90dGxlLCBkdXJhdGlvbiwgb3B0aW9ucyk7XG5cbn1cbiJdfQ==